export const columnHeaders = {
  data: 'Date',
  metered: 'Metered',
  scanned: 'Scanned',
  expenses: 'Cost'
}
